import { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { Reveal, Stagger, StaggerItem } from "@/components/Motion";
import Seo from "@/components/Seo";
import api from "@/lib/api";

export default function Blog() {
  const [articles, setArticles] = useState([]);
  const [cat, setCat] = useState("Tutti");
  useEffect(() => { api.get("/blog").then((r) => setArticles(r.data)).catch(() => {}); }, []);

  const cats = useMemo(() => ["Tutti", ...Array.from(new Set(articles.map((a) => a.category)))], [articles]);
  const list = cat === "Tutti" ? articles : articles.filter((b) => b.category === cat);

  return (
    <div className="pt-32 pb-28 min-h-screen">
      <Seo title="Blog — Spiritualità moderna e Registri Akashici" description="Articoli su Registri Akashici, spiritualità moderna, crescita personale, energia e meditazione firmati LUX AETERNA." type="blog" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-gold mb-5">Blog</p>
          <h1 className="font-display text-5xl sm:text-7xl text-[#2A1F14] leading-[1.02] max-w-3xl mb-8">Il riferimento della spiritualità moderna.</h1>
        </Reveal>

        <div className="flex flex-wrap gap-2.5 mt-12 mb-14">
          {cats.map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`blog-filter-${c}`}
              className={`px-4 py-1.5 rounded-full text-xs border transition-colors ${cat === c ? "bg-gold text-black border-gold" : "border-[#2A1F14]/15 text-[#2A1F14]/55 hover:border-gold/50 hover:text-[#2A1F14]"}`}>
              {c}
            </button>
          ))}
        </div>

        {list.length === 0 ? (
          <p className="text-[#2A1F14]/40">Nessun articolo in questa categoria.</p>
        ) : (
          <Stagger className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-14">
            {list.map((b) => (
              <StaggerItem key={b.slug}>
                <Link to={`/blog/${b.slug}`} data-testid={`blog-${b.slug}`} className="block group">
                  {b.cover && (
                    <div className="aspect-[16/10] rounded-xl overflow-hidden mb-5">
                      <img src={b.cover} alt={b.title} className="w-full h-full object-cover opacity-85 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700" loading="lazy" />
                    </div>
                  )}
                  <p className="text-[10px] uppercase tracking-[0.2em] text-gold mb-3">{b.category}</p>
                  <h3 className="font-display text-2xl text-[#2A1F14] mb-3 group-hover:text-gold transition-colors leading-snug">{b.title}</h3>
                  <p className="text-[#2A1F14]/45 text-sm leading-relaxed mb-4">{b.excerpt}</p>
                  <p className="text-[#2A1F14]/30 text-xs">{b.date} · {b.author}</p>
                </Link>
              </StaggerItem>
            ))}
          </Stagger>
        )}
      </div>
    </div>
  );
}
